import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import './Confermation.scss'
function MakedefaultModalForm(props) {
    const { setMakedefaultModal, makedefaultModal, makeDefaultHeading, confermationMessage, buttonLable, handleDefault , isLoading , warning } = props
    const toggle = () => setMakedefaultModal(!makedefaultModal)
    return (
        <div>
            <Modal isOpen={makedefaultModal} toggle={toggle} {...props}>
                <ModalHeader toggle={toggle}><h6>{makeDefaultHeading}</h6></ModalHeader>
                <ModalBody className='text-center'><b>{confermationMessage}</b>
                {warning && warning != '' ? <p className='text-center small'>{warning}</p> : ''}
                </ModalBody>
                
                <ModalFooter>
                    <Button className='modalButton' color={buttonLable === 'Delete' ? 'danger' : 'primary'} disabled={isLoading ? true : false} onClick={handleDefault}>{buttonLable}</Button>{' '}
                    <Button className='modalButton' color="secondary" onClick={toggle}> Cancel </Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}
MakedefaultModalForm.propTypes = {
    dispatch: PropTypes.func,
    setMakedefaultModal: PropTypes.func,
    makedefaultModal: PropTypes.bool,
    makeDefaultHeading: PropTypes.string,
    confermationMessage: PropTypes.string,
    buttonLable: PropTypes.string,
    handleDefault: PropTypes.func,
    isLoading: PropTypes.bool,
    warning : PropTypes.string
}
MakedefaultModalForm.defaulProps = {
    dispatch: noop,
    setMakedefaultModal: PropTypes.func,
    makedefaultModal: PropTypes.bool,
    makeDefaultHeading: PropTypes.string,
    confermationMessage: PropTypes.string,
    buttonLable: PropTypes.string,
    handleDefault: PropTypes.func,
    isLoading : PropTypes.bool,
    warning : PropTypes.string
}
function mapStateToProps() {
    return {}
}
export default connect(mapStateToProps)(MakedefaultModalForm)